import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";

// components
import TooltipWithMessage from "core/TooltipWithMessage";
import CCBasic from "./LicenseTooltips/CCBasic";
import CCAlaCartRoyaltyFree from "./LicenseTooltips/CCAlaCartRoyaltyFree";

const licenseMessageMap = {
    PUBLIC: {
        prePurchase: "Public Domain JPG Photo",
        postPurchase: "Public Domain, free to use",
        toolTipText: ""
    },
    BASIC: {
        prePurchase: "Standard JPG Photo",
        postPurchase: "CC BY-NC-ND 2.0 License",
        toolTipText: <CCBasic />
    },
    STANDARD_PHOTO: {
        prePurchase: "Standard JPG Photo",
        postPurchase: "Royalty-Free Commercial Licence",
        toolTipText: <CCAlaCartRoyaltyFree />
    },
    PREMIUM_PHOTO: {
        prePurchase: "Premium JPG Photo",
        postPurchase: "Royalty-Free Commercial Licence",
        toolTipText: <CCAlaCartRoyaltyFree />
    }
};

const License = () => {
    const { state } = useContext(AssetDownloadContext);

    const {
        purchaseType: { key },
        isReadyForDownload
    } = state;

    const licenseMessages = licenseMessageMap[key];

    const licenseText = isReadyForDownload
        ? licenseMessages?.postPurchase
        : licenseMessages?.prePurchase;

    const toolTipText = isReadyForDownload ? licenseMessages?.toolTipText : "";

    return <TooltipWithMessage text={licenseText} toolTipText={toolTipText} />;
};

export default License;
